import React from "react";
import IMSInfoDelete from "../utils/IMSInfoDelete";
import { Button, ControlGroup, Tag } from "@blueprintjs/core";
import EntityComments from "./EntityComments";
import EntityFiles from "./EntityFiles";
import AnaesthesiaPriceMaster from "./AnaesthesiaPriceMaster";
import BedMaster from "./BedMaster";
import SxPriceMaster from "./SxPriceMaster";
import SxSurgeonSchedules from "./SxSurgeonSchedules";
import SxAnaesthetistSchedule from "./SxAnaesthetistSchedule";
import SxMaster from "./SxMaster";
import PostSxContactMaster from "./PostSxContactMaster";
import AdverseEventMaster from "./AdverseEventMaster";

class MasterRow extends React.Component {
  state = {
    changed: false,
    updatedPropObject: null,
  };
  renderRow = () => {
    if (this.props.entityType === "SxPostSurgeryContactList") {
      return (
        <PostSxContactMaster
          sites={this.props.sites}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
    if (this.props.entityType === "SxAdverseEventMaster") {
      return (
        <AdverseEventMaster
          sites={this.props.sites}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
    if (this.props.entityType === "sxAnaesthesiaPriceMaster") {
      return (
        <AnaesthesiaPriceMaster
          sites={this.props.sites}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
    if (this.props.entityType === "sxAnaesthesiaPriceMaster") {
      return (
        <AnaesthesiaPriceMaster
          sites={this.props.sites}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
    if (this.props.entityType === "sxBooking") {
      return (
        <SxMaster
          sites={this.props.sites}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }

    // if (this.props.entityType === "sxPriceMaster") {
    //   return (
    //     <SxPriceMaster
    //       entity={this.props.entity}
    //       sites={this.props.sites}
    //       data={this.props.data}
    //       onUpdate={(updatedPropObject) =>
    //         this.setState({
    //           updatedPropObject: updatedPropObject,
    //           changed: true,
    //         })
    //       }
    //     />
    //   );
    // }
    if (this.props.entityType === "sxSurgeonSchedule") {
      return (
        <SxSurgeonSchedules
          sites={this.props.sites}
          data={this.props.data}
          docs={this.props.docs}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
          onDelete={() => this.props.onDelete()}
        />
      );
    }
    if (this.props.entityType === "sxAnaesthetistSchedule") {
      return (
        <SxAnaesthetistSchedule
          sites={this.props.sites}
          data={this.props.data}
          docs={this.props.docs}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
    if (this.props.entityType === "sxBedMaster") {
      return (
        <BedMaster
          sites={this.props.sites}
          data={this.props.data}
          onUpdate={(updatedPropObject) =>
            this.setState({
              updatedPropObject: updatedPropObject,
              changed: true,
            })
          }
        />
      );
    }
  };
  renderSave = () => {
    if (!this.state.changed) {
      return null;
    }
    if (this.props.entityType === "prices") {
      if (!this.props.data.isCurrent) {
        return (
          <ControlGroup>
            <Tag large>This is an obsolete price and cannot be edited</Tag>
          </ControlGroup>
        );
      }
    }
    return (
      <ControlGroup>
        <Button
          loading={this.props.isBusy}
          disabled={this.props.isBusy}
          fill
          intent="success"
          text="Save Changes"
          icon="endorsed"
          onClick={() => {
            let payload = this.state.updatedPropObject || this.props.data;
            payload["entityName"] = this.state.changedName ? this.state.entityName : this.props.data.entityName;
            payload["isShell"] = false;
            this.setState({ isUpdating: true }, () => this.props.onUpdate(payload));
          }}
        />
        <Button
          disabled={this.props.isBusy}
          icon="delete"
          text="Cancel"
          onClick={() => this.setState({ changed: false })}
        />
      </ControlGroup>
    );
  };
  render() {
    return (
      <tr className={this.state.changed ? "unsaved__bg" : ""}>
        {this.renderRow()}
        {this.props.entityType === "sxBooking" ? null : (
          <>
            <td>{this.renderSave()}</td>
            {this.props.entityType === "sxSurgeonSchedule" || this.props.entityType === "sxPriceMaster" ? null : (
              <>
                <td>
                  <EntityComments data={this.props.data} isTable={true} />
                </td>
                <td>
                  <EntityFiles data={this.props.data} isTable={true} />
                </td>
                <td>
                  <IMSInfoDelete
                    isVertical={true}
                    disabled={this.props.isBusy}
                    changed={this.state.changed}
                    data={this.props.data}
                    onDelete={() => this.props.onDelete()}
                  />
                </td>
              </>
            )}
          </>
        )}
      </tr>
    );
  }
}

export default MasterRow;
